import { useAtomValue } from "jotai";
import { activePopupState } from "../../../state/components/popup";
import type { PopupInfo } from "../../../state/components/popup";

interface ConfirmPopupInfo extends PopupInfo {
  onConfirm?: () => void;
}

const Confirm = ({ hide }: { hide: () => void }) => {
  const infoPopup = useAtomValue(
    activePopupState("confirm"),
  ) as ConfirmPopupInfo | null;

  return (
    <>
      <div className="jf-popup-media_content-title">Action</div>
      <div>{infoPopup?.message}</div>
      <div className="jf-action">
        <button
          className="jf-btn jf-btn-primary-light"
          onClick={() => {
            infoPopup?.onConfirm?.();
            hide();
          }}
        >
          Yes
        </button>
        <button
          className="jf-btn jf-btn-danger-light"
          onClick={() => {
            hide();
          }}
        >
          No
        </button>
      </div>
    </>
  );
};

export default Confirm;
